
import { withSchema } from '@websolutespa/bom-core';
import { RadioColorBase, RadioColorComponent } from './radio-color-base';
import { RadioColorGroup } from './radio-color-group';

export const RadioColor: RadioColorComponent & {
  Group: typeof RadioColorGroup;
} = withSchema(
  RadioColorBase,
  {
    Group: RadioColorGroup,
  });
